export interface Feature {
  key: string
  title: string
  description: string
  image: string
}

export const keyFeatures: Feature[] = [
  {
    key: 'product-listings',
    title: 'home.keyFeatures.productListings.title',
    description: 'home.keyFeatures.productListings.description',
    image: '/screens/product-listings.png'
  },
  {
    key: 'image-management',
    title: 'home.keyFeatures.imageManagement.title',
    description: 'home.keyFeatures.imageManagement.description',
    image: '/screens/image-management.png'
  },
  {
    key: 'performance-reports',
    title: 'home.keyFeatures.performanceReports.title',
    description: 'home.keyFeatures.performanceReports.description',
    image: '/screens/performance-reports.png'
  }
]

export interface DetailedFeature {
  key: string
  title: string
  description: string
  image: string
  imagePosition: 'left' | 'right'
}

export const detailedFeatures: DetailedFeature[] = [
  {
    key: 'product-listing-management',
    title: 'features.detailed.productListingManagement.title',
    description: 'features.detailed.productListingManagement.description',
    image: '/screens/product-listing-management.png',
    imagePosition: 'left'
  },
  {
    key: 'image-management-ai',
    title: 'features.detailed.imageManagementAI.title',
    description: 'features.detailed.imageManagementAI.description',
    image: '/screens/image-management-ai.png',
    imagePosition: 'right'
  },
  {
    key: 'reporting-insights',
    title: 'features.detailed.reportingInsights.title',
    description: 'features.detailed.reportingInsights.description',
    image: '/screens/reporting-insights.png',
    imagePosition: 'left'
  },
  {
    key: 'ad-performance-monitoring',
    title: 'features.detailed.adPerformanceMonitoring.title',
    description: 'features.detailed.adPerformanceMonitoring.description',
    image: '/screens/ad-performance-monitoring.png',
    imagePosition: 'right'
  },
  {
    key: 'inventory-orders',
    title: 'features.detailed.inventoryOrders.title',
    description: 'features.detailed.inventoryOrders.description',
    image: '/screens/inventory-orders.png',
    imagePosition: 'left'
  },
  {
    key: 'task-management-workflows',
    title: 'features.detailed.taskManagementWorkflows.title',
    description: 'features.detailed.taskManagementWorkflows.description',
    image: '/screens/task-management-workflows.png',
    imagePosition: 'right'
  }
]